import React from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import WaitDialog from '../../../widgets/WaitDialog';
import EditFatturaInsegnanteWidget from '../../../widgets/EditFatturaInsegnanteWidget';
import getFattureInsegnante from "../../../services/getFattureInsegnante";
import addFattura from "../../../services/addFattura";
import editFattura from "../../../services/editFattura";
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../../utils/Locales";

let t = translateString;

export default class FattureInsegnante extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.fatture = [];

    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      fusioneEnabled: false,
      insegnanti: [],
      gruppiInsegnantiComplete: [],
      mailCompaniesList: [],
      reportPeriod: '',
      waitDialogFileVisible: false,
      editFatturaWidget: false,
      fileReady: false
    }

    this.grid = 2;
    this.editFatturaRef = React.createRef();

    this.pdfElements = [];

    this.insegnanti = [];
    this.gruppiInsegnantiComplete = [];
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
        isLoading: true
    };

  }


  async reload(){
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
    
    this.fatture = await getFattureInsegnante(username, token, currentInsegnante);
    

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();

  }  

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <div id={Math.random()}>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('fatture_insegnante')} button={t('nuova').toUpperCase()} onClick={() => {
            this.setState({currentFattura: undefined, editFatturaWidget: true})
            var fattura = {};
            this.editFatturaRef.current.refresh(fattura);

          }}/>

        <div>
        { (!this.fatture || this.fatture.length === 0) &&
           <div style={{ marginTop: 100, display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
              <img src={ require('../../../images/nothing.png') } style={{ width: 200, height: 200, opacity: 0.5 }} />
              <p style={{ color: 'darkgrey', fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginLeft: 40, marginRight: 40 }}>{t('no_dati')}</p>
          </div>
        }
        {
          this.fatture.map (fattura => {
            return <div key={Math.random()} style={rataDiv} onClick={
              () => {
                this.setState({currentFattura: fattura, editFatturaWidget: true});
                this.editFatturaRef.current.refresh(fattura);
              }
            }>
              <div style={textDiv}><b>{t('data')}</b>: {fattura.data}</div>
              <div style={textDiv}><b>{t('importo')}</b>: {fattura.importo}</div>
              <div style={textDiv}><b>{t('stato_pagamento')}</b>: {fattura.flag_pagamento == 1 ? t('PAGATA') : t('NON PAGATA')}</div>
              <div style={textDiv}><b>{t('note')}</b>: {fattura.note}</div>
            </div>
          })
        }

        </div>

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        <EditFatturaInsegnanteWidget 
            ref={this.editFatturaRef}
            show={this.state.editFatturaWidget}
            fattura={this.state.currentFattura}
            onClose={async fattura => {
              if (fattura === null) {
                this.setState({editFatturaWidget: false});
                return;
              } else if (fattura === undefined) {
                this.reload();
                this.setState({editFatturaWidget: false});
                return;
              }

              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
          
              if (fattura.id === undefined)
                await addFattura(username, token, currentInsegnante, fattura.data, fattura.importo, fattura.file, fattura.note, fattura.status == 'PAGATA' ? 1 : 0);
              else   
                await editFattura(username, token, fattura.id, currentInsegnante, fattura.data, fattura.importo, fattura.file, fattura.note, fattura.status == 'PAGATA' ? 1 : 0);

              this.setState({editFatturaWidget: false});
              this.reload();
          }}
        />
        </LoadingOverlay>
      </div>
    );
  }
}

const rataDiv = {
  borderRadius: '10px',
  padding: '10px',
  paddingLeft: 20, 
  paddingTop: 20, 
  paddingBottom: 20, 
  cursor: 'pointer',
  marginBottom: 10,
  boxShadow: '0px 2px 10px lightgrey',
}

const textDiv = {
  marginLeft: 20,
}